import React from 'react';

const ListContainer = ({ children, className = "" }) => {
  return (
    <div className={`bg-transparent ${className}`}>
      {children}
    </div>
  );
};

export default ListContainer;